import { MdInbox, MdOutlineInbox } from "react-icons/md";
import { toast } from "react-toastify";

export const useNotificationSnack = () => {
  const showNotificationSnack = (message, autoClose = 3000) => {
    const toastOptions = {
      autoClose,
      containerId: "notification",
      style: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px 16px",
        fontSize: "15px",
        fontWeight: 500,
        backgroundColor: "#ffffff",
        color: "#1c1e21",
        borderRadius: "10px",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e4e6eb",
        maxWidth: "400px",
      },
      icon: false, // we'll inject our own icon manually if needed
    };

    toast(
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={{ fontSize: "20px" }}>
          <MdOutlineInbox />
        </span>
        <span>{message}</span>
      </div>,
      toastOptions
    );
  };

  return { showNotificationSnack };
};
